import { render, staticRenderFns } from "./selectSchool.vue?vue&type=template&id=b5ad04c2&scoped=true&"
import script from "./selectSchool.vue?vue&type=script&lang=js&"
export * from "./selectSchool.vue?vue&type=script&lang=js&"
import style0 from "./selectSchool.vue?vue&type=style&index=0&id=b5ad04c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ad04c2",
  null
  
)

export default component.exports